export const downloadTemplate = (payload = {}, mode = '') => {
  return {
    type: 'DOWNLOAD_TEMPLATE',
    payload,
    mode,
    loader: true,
  };
};
export const setBulkSubmitStatus = data => {
  return {
    type: 'SET_BULK_SUBMIT_STATUS',
    data,
    loader: false,
  };
};
export const setErrorData = data => {
  return {
    type: 'SET_ERROR_DATA',
    data,
  };
};
